/* eslint-disable no-unused-expressions, curly */

import { scrollLock, scrollUnlock } from 'ui/scrollLock';


/**
 * @module Video
 */
class Video {

    /**
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - externally added options
     */
    constructor(element, options = {}) {
        this._element = element;
        this._options = {
            ...options,
            pauseState: 4,
            seekingState: 1
        };

        this._state = {
            scrollTop: 0,
            isTouch: false
        };

        this._handlePlayClicked = this._handlePlayClicked.bind(this);
        this._handlePausedVideo = this._handlePausedVideo.bind(this);
        this._setIsTouch = this._setIsTouch.bind(this);

        this._cacheSelectors();
        this._addListeners();
    }

    /**
     * Cache selectors
     *
     * @memberof Video
     */
    _cacheSelectors() {
        this._video = this._element.querySelector('video');
        this._playButton = this._element.querySelector('.video__play');
    }

    /**
     * Add listeners
     *
     * @memberof Video
     */
    _addListeners() {
        this._playButton.addEventListener('click', event => this._handlePlayClicked(event));
        document.documentElement.addEventListener('touchmove', this._setIsTouch, false);
    }

    /**
     * Set touch state
     *
     * @memberof Video
     */
    _setIsTouch() {
        this._state.isTouch = true;
        document.documentElement.removeEventListener('touchmove', this._setIsTouch);
    }

    /**
     * On click set playing status and add pause listeners
     *
     * @memberof Video
     * @param {event} event
     */
    _handlePlayClicked(event) {
        event.preventDefault();
        this._state.isTouch && scrollLock();
        this._handleScrollPosition();
        this._element.setAttribute('data-playing', true);
        this._addPauseListener();
        this._video.play();
        this._video.setAttribute('controls', 'controls');
    }

    /**
     * On pause set playing status and remove pause listeners
     *
     * @memberof Video
     */
    _handlePausedVideo() {
        this._state.isTouch && scrollUnlock();
        const isPaused = this._video.readyState === this._options.pauseState;
        this._element.setAttribute('data-playing', !isPaused);
        isPaused && this._video.removeEventListener('pause', this._handlePausedVideo);
        isPaused && this._video.removeAttribute('controls');
        document.documentElement.scrollTop = this._state.isTouch ? this._state.scrollTop : document.documentElement.scrollTop;
    }

    /**
     * Set the scroll state on click
     *
     * @memberof Video
     */
    _handleScrollPosition() {
        if (!this._state.isTouch) return;
        this._state.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    }

    /**
     * Set pause and seek listeners
     *
     * @memberof Video
     */
    _addPauseListener() {
        this._video.addEventListener('pause', this._handlePausedVideo, true);
    }
}

export default Video;
